export enum PostponedCommissionsReport {
  UNRESOLVED = "UNRESOLVED",
  UNRESOLVED_INCLUDED_IN_BATCH = "UNRESOLVED_INCLUDED_IN_BATCH",
  RESOLVED = "RESOLVED",
}

export enum PostponedCommissionsOrderByColumn {
  BATCH_NAME = "BATCH_NAME",
  DUPLICATE_OF_BATCH_NAME = "DUPLICATE_OF_BATCH_NAME",
  COMMISSION_BASE_AMOUNT = "COMMISSION_BASE_AMOUNT",
  COMMISSION_AMOUNT = "COMMISSION_AMOUNT",
}
